import * as middlewares from './middlewares';
import * as sagas from './sagas';
import {rootReducer} from './root-reducer';
import {version} from './version/reducer';
import {all, call} from 'redux-saga/effects';
import {createStore, applyMiddleware} from 'redux';
import {get, cookies, config, map, handleError} from 'helpers';
import createSagaMiddleware from 'redux-saga';
import {instance} from './helpers';

export const store = configureStore(typeof window === 'object');

instance.current = store;

function configureStore(isBrowser: boolean) {
  if (!isBrowser) {
    return createStore(rootReducer);
  }

  if (window.sagaTask) {
    window.sagaTask.cancel();
  }

  let preloadedState = JSON.parse(window.localStorage.getItem('store')) || {};

  if (get(preloadedState, 'session.token') !== cookies.get('token') || preloadedState.version !== version()) {
    window.localStorage.clear();
    preloadedState = {};
  }

  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(rootReducer, preloadedState, applyMiddleware(
    // order is important here
    middlewares.generateIds,
    middlewares.activities,
    middlewares.select,
    middlewares.timestamp,
    middlewares.permissions,
    middlewares.customEvent,
    sagaMiddleware,
  ));

  const sagaTask = sagaMiddleware.run(function* sagaMiddleware () {
    yield all(map(sagas, wrapWithHandleError));
  });

  if (config.development) {
    window.sagaTask = sagaTask;
    window.store = store;
  }

  return store;
}

function wrapWithHandleError(saga) {
  return call(function*() {
    try {
      yield call(saga);
    } catch (error) {
      handleError(error, {func: saga});
    }
  });
}
